import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ba5a1774"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "basePageWraper pagefull" }
const _hoisted_2 = { class: "centerWrap" }
const _hoisted_3 = { class: "cont" }
const _hoisted_4 = { class: "wrap" }
const _hoisted_5 = { class: "nTitle" }
const _hoisted_6 = { class: "mt-2 columns is-mobile" }
const _hoisted_7 = { class: "column is-three-quarters" }
const _hoisted_8 = { class: "column has-text-right" }
const _hoisted_9 = { class: "nImgWriteWrap" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item left" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-chevron-right" })
], -1))
const _hoisted_11 = { class: "item right" }
const _hoisted_12 = { class: "select mr-2" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "0" }, "작성중", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "비공개", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "2" }, "공개", -1))
const _hoisted_16 = [
  _hoisted_13,
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = { class: "img_list" }
const _hoisted_18 = {
  class: "wrap box scrollBar_x",
  ref: "img_list_wrap"
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "btnWrap" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-angle-left" }, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-angle-right" }, null, -1))
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-xmark" }, null, -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = {
  key: 0,
  class: "blankText has-text-grey-light"
}
const _hoisted_29 = { class: "nTopWriteBtnWrap" }
const _hoisted_30 = { class: "nEditor" }
const _hoisted_31 = { class: "nBottomWriteBtnWrap mb-3" }
const _hoisted_32 = {
  key: 0,
  class: "img_select modal is-active"
}
const _hoisted_33 = { class: "modal-card" }
const _hoisted_34 = { class: "modal-card-head" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "modal-card-title" }, "이미지 등록", -1))
const _hoisted_36 = { class: "modal-card-body" }
const _hoisted_37 = { class: "tabs" }
const _hoisted_38 = {
  key: 0,
  class: "search_page"
}
const _hoisted_39 = { class: "my_grid columns is-multiline is-mobile mt-4" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "l_icon p-0 column is-half" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-play has-text-success" }, null, -1))
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = { class: "r_icon p-0 column is-half" }
const _hoisted_46 = ["onClick"]
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-xmark" }, null, -1))
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = { class: "mt-2 has-text-left" }
const _hoisted_50 = {
  key: 1,
  class: "img_add_page"
}
const _hoisted_51 = { class: "box" }
const _hoisted_52 = {
  key: 0,
  class: "preview_up_img"
}
const _hoisted_53 = ["src"]
const _hoisted_54 = { class: "add_img_wrap" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "file_up_load" }, "업로드", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "has-text-right has-text-grey mt-2" }, " 태그는 클릭으로 삭제 가능합니다. ", -1))
const _hoisted_57 = { class: "tag_list box mt-2 p-3 has-text-left is-mobile" }
const _hoisted_58 = {
  key: 0,
  class: "has-text-centered has-text-grey-light"
}
const _hoisted_59 = ["onClick"]
const _hoisted_60 = { class: "has-text-center mt-2" }
const _hoisted_61 = { class: "m_footer modal-card-foot" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_editor_v3 = _resolveComponent("md-editor-v3")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.wd.title) = $event)),
              type: "text",
              class: "input",
              placeholder: "제목을 입력하세요."
            }, null, 512), [
              [_vModelText, _ctx.wd.title]
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.wd.url_key) = $event)),
                type: "text",
                class: "input",
                placeholder: "페이지 URL을 입력하세요"
              }, null, 512), [
                [_vModelText, _ctx.wd.url_key]
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clickBtnRandomUrl && _ctx.clickBtnRandomUrl(...args))),
                class: "button is-link"
              }, "랜덤")
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.wd.open_type) = $event))
                }, _hoisted_16, 512), [
                  [_vModelSelect, _ctx.wd.open_type]
                ])
              ]),
              _createElementVNode("button", {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.open_img_select_pop(true))),
                class: "button is-link"
              }, "이미지 등록")
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selected_img_list, (d, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  onClick: ($event: any) => (_ctx.click_selected_img(d)),
                  class: _normalizeClass([{'active' : d.file_name == _ctx.wd.main_img}, "item selector"]),
                  key: idx,
                  style: _normalizeStyle({ backgroundImage: 'url(' + _ctx.getImg(d.file_name)+ ')' })
                }, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", {
                      class: "left",
                      onClick: ($event: any) => (_ctx.clickCodeCopy(d))
                    }, _hoisted_24, 8, _hoisted_21),
                    _createElementVNode("div", {
                      class: "right",
                      onClick: ($event: any) => (_ctx.clickDelImg(d))
                    }, _hoisted_27, 8, _hoisted_25)
                  ])
                ], 14, _hoisted_19))
              }), 128)),
              ((_ctx.selected_img_list.length == 0))
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, " 이미지를 등록 하여 사용 할 수 있습니다. "))
                : _createCommentVNode("", true)
            ], 512)
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("button", {
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.clickBoardSave && _ctx.clickBoardSave(...args))),
              class: "button is-link"
            }, "문서등록")
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createVNode(_component_md_editor_v3, {
              class: "MyEditor",
              noUploadImg: true,
              toolbars: ['bold', 'underline', 'italic',
              'strikeThrough', 'title', 'sub', 'sup',
              'quote', 'unorderedList',
              'orderedList', 'task', 'codeRow', 'code',
              'link', 'table', 'mermaid', 'katex',
              'revoke', 'next',
              'image',
              '-', '=', 'pageFullscreen'
            ],
              style: {"text-align":"left"},
              modelValue: _ctx.wd.cont,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.wd.cont) = $event)),
              language: "en-US",
              ref: "editorRef"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("button", {
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.clickBoardSave && _ctx.clickBoardSave(...args))),
              class: "button is-link"
            }, "문서등록")
          ])
        ])
      ])
    ]),
    (_ctx.is_img_select_open)
      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
          _createElementVNode("div", {
            class: "modal-background",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.open_img_select_pop(false)))
          }),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("header", _hoisted_34, [
              _hoisted_35,
              _createElementVNode("button", {
                class: "delete",
                "aria-label": "close",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.open_img_select_pop(false)))
              })
            ]),
            _createElementVNode("section", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", {
                    class: _normalizeClass({'is-active' : _ctx.selected_img_pop_up_menu == 'search'})
                  }, [
                    _createElementVNode("a", {
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.set_selected_img_pop_up_menu('search')))
                    }, "이미지 검색")
                  ], 2),
                  _createElementVNode("li", {
                    class: _normalizeClass({'is-active' : _ctx.selected_img_pop_up_menu == 'add'})
                  }, [
                    _createElementVNode("a", {
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.set_selected_img_pop_up_menu('add')))
                    }, "이미지 추가")
                  ], 2)
                ])
              ]),
              (_ctx.selected_img_pop_up_menu=='search')
                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        onKeypress: _cache[12] || (_cache[12] = _withKeys(
//@ts-ignore
(...args) => (_ctx.bindGetListImgSearchVal && _ctx.bindGetListImgSearchVal(...args)), ["enter"])),
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.img_search_val) = $event)),
                        class: "input",
                        placeholder: "검색어를 입력하세요"
                      }, null, 544), [
                        [_vModelText, _ctx.img_search_val]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr_img_list, (d) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "column is-half",
                          key: d.img_idx
                        }, [
                          _createElementVNode("div", {
                            onClick: ($event: any) => (_ctx.click_selectImg(d)),
                            class: "img_item m-0 is-mobile columns is-centered is-clickable",
                            style: _normalizeStyle({ backgroundImage: 'url(' + _ctx.getImg(d.file_name) + ')' }),
                            loading: "lazy"
                          }, [
                            _createElementVNode("div", _hoisted_41, [
                              _createElementVNode("div", {
                                class: "ic",
                                onClick: ($event: any) => (_ctx.showImgPop(d))
                              }, _hoisted_44, 8, _hoisted_42)
                            ]),
                            _createElementVNode("div", _hoisted_45, [
                              _createElementVNode("div", {
                                class: "ic",
                                onClick: ($event: any) => (_ctx.delete_imgList(d))
                              }, _hoisted_48, 8, _hoisted_46)
                            ])
                          ], 12, _hoisted_40),
                          _createElementVNode("div", _hoisted_49, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(d.tag, (tag, idx) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: idx,
                                class: "tag is-link is-medium is-clickable is-unselectable mr-1 mt-1"
                              }, _toDisplayString(tag), 1))
                            }), 128))
                          ])
                        ]))
                      }), 128))
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("button", {
                        onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.bindGetNextImgSearch && _ctx.bindGetNextImgSearch(...args))),
                        class: "button"
                      }, "더보기")
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.selected_img_pop_up_menu=='add')
                ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, [
                      (_ctx.add_img_page.add_img != '')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                            _createElementVNode("img", { src: _ctx.add_img_url }, null, 8, _hoisted_53)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_54, [
                        _hoisted_55,
                        _createElementVNode("input", {
                          type: "file",
                          id: "file_up_load",
                          onChange: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.changeUpImg && _ctx.changeUpImg(...args)))
                        }, null, 32)
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.add_img_page.add_input_text) = $event)),
                        onKeypress: _cache[17] || (_cache[17] = _withKeys(
//@ts-ignore
(...args) => (_ctx.add_img_search_text && _ctx.add_img_search_text(...args)), ["enter"])),
                        type: "text",
                        class: "input",
                        placeholder: "이미지 검색어(태그) 입력 하세요"
                      }, null, 544), [
                        [_vModelText, _ctx.add_img_page.add_input_text]
                      ])
                    ]),
                    _hoisted_56,
                    _createElementVNode("div", _hoisted_57, [
                      ((_ctx.add_img_page.add_tag_list.length == 0))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_58, "검색어를 입력하세요.(엔터)"))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.add_img_page.add_tag_list, (d) => {
                        return (_openBlock(), _createElementBlock("span", {
                          class: "tag is-link is-medium is-clickable is-unselectable",
                          key: d,
                          onClick: ($event: any) => (_ctx.del_img_tag(d))
                        }, _toDisplayString(d), 9, _hoisted_59))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("button", {
                        onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.save_add_img && _ctx.save_add_img(...args))),
                        class: "button is-link is-fullwidth"
                      }, "저장")
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("footer", _hoisted_61, [
              _createElementVNode("button", {
                class: "button",
                onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.open_img_select_pop(false)))
              }, "닫기")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}